import { cn } from '@/lib/utils';

interface FunnelStep {
  name: string;
  valor: number;
  fill: string;
}

interface FunnelChartProps {
  data: FunnelStep[];
}

export function FunnelChart({ data }: FunnelChartProps) {
  const maxValue = Math.max(...data.map(d => d.valor));

  return (
    <div className="flex flex-col">
      <div className="flex-1 flex flex-col justify-center space-y-2">
        {data.map((step, index) => {
          const percentage = (step.valor / maxValue) * 100;
          const conversionRate = index > 0 
            ? ((step.valor / data[index - 1].valor) * 100).toFixed(1)
            : '100';
          
          return (
            <div key={step.name} className="space-y-1">
              <div className="flex items-center justify-between text-[10px]">
                <span className="text-muted-foreground font-medium truncate max-w-[100px]">
                  {step.name}
                </span>
                <span className="flex items-center gap-2">
                  <span className="font-bold text-foreground">
                    {step.valor.toLocaleString('pt-BR')}
                  </span>
                  {index > 0 && (
                    <span className={cn(
                      "px-1.5 py-0.5 rounded text-[9px] font-bold",
                      Number(conversionRate) >= 80 
                        ? "bg-[hsl(var(--accent-100))] text-[hsl(var(--accent-700))]"
                        : Number(conversionRate) >= 60
                          ? "bg-[hsl(38,92%,90%)] text-[hsl(38,92%,35%)]"
                          : "bg-[hsl(var(--careful-100))] text-[hsl(var(--careful-700))]"
                    )}>
                      {conversionRate}%
                    </span>
                  )}
                </span>
              </div>
              <div className="h-6 bg-muted rounded-lg overflow-hidden">
                <div 
                  className="h-full rounded-lg transition-all duration-500 ease-out flex items-center justify-end pr-2"
                  style={{ 
                    width: `${percentage}%`,
                    backgroundColor: step.fill
                  }}
                >
                  {percentage > 20 && (
                    <span className="text-[9px] font-bold text-white">
                      {percentage.toFixed(0)}%
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Summary */}
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-[10px] text-muted-foreground">Taxa de conversão total</span>
          <span className="text-sm font-bold text-[hsl(var(--accent-600))]">
            {((data[data.length - 1].valor / data[0].valor) * 100).toFixed(1)}%
          </span>
        </div>
      </div>
    </div>
  );
}
